import {graphql} from 'gatsby'
import React from 'react'

import type {
    CustomersLogosPlusHeadlineSliceFragment,
    PartnerTemplateCustomersLogosPlusHeadlineFragment,
} from '@/graphql-types'
import TitleWithIconGridSection from '@/sections/title-with-icon-grid'

type Props = {
    slice:
        | CustomersLogosPlusHeadlineSliceFragment
        | PartnerTemplateCustomersLogosPlusHeadlineFragment
    dataTestId?: string
}

export const CustomersLogosPlusHeadlineSlice = ({slice, dataTestId}: Props) => {
    const title =
        slice.primary.predefined_logos.document?.data.title ?? slice.primary.customer_logos_title
    const logos = slice.primary.predefined_logos.document?.data.logos ?? slice.items

    return (
        <TitleWithIconGridSection
            titleVariant="heading-large"
            highlightColor="yellow"
            title={title.richText}
            items={logos}
            dataTestId={dataTestId}
        />
    )
}

export const customersLogosPlusHeadlineFragment = graphql`
    fragment CustomersLogosPlusHeadlineSlice on PrismicSlicePageDataBodyCustomersLogosPlusHeadline {
        __typename
        primary {
            predefined_logos {
                document {
                    ... on PrismicCustomersLogosSection {
                        data {
                            title {
                                richText
                            }
                            logos {
                                icon: logo {
                                    alt
                                    copyright
                                    url
                                    dimensions {
                                        height
                                        width
                                    }
                                }
                            }
                        }
                    }
                }
            }
            customer_logos_title {
                richText
            }
        }
        items {
            icon: customer_logo {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
            }
        }
    }
`
